import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  makeStyles,
} from '@material-ui/core';
import { translate } from '../../Services/translation';

const useStyles = makeStyles({
  root: {
    '& .MuiInputBase-root': {
      boxSizing: 'border-box',
      height: '48px',
      marginBottom: '12px',
      borderRadius: '99px',
      border: '1px solid #E7E7E7',
    },
    '& .MuiOutlinedInput-input': {
      color: 'green',
    },
    '& .MuiFormControl-root label': {
      fontSize: '16px',
    },
    '& .MuiInput-underline:before': {
      display: 'none',
    },
    '& .MuiInput-underline:after': {
      display: 'none',
    },
    '& .MuiSelect-root': {
      padding: '0 24px',
    },
    '& .MuiSelect-root > .sizeselect__inventory': {
      display: 'none',
    },
    '& .MuiSelect-root:focus': {
      backgroundColor: 'transparent',
    },
    '& .MuiMenu-paper': {
      marginTop: '60px',
    },
    '& .MuiListItem-button': {
      justifyContent: 'space-between',
    },
    '& .MuiListItem-root': {
      display: 'flex',
      justifyContent: 'space-between',
    },
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const ProductSizeSelector = ({ sizes }) => {
  const [selectedSize, setSelectedSize] = useState(
    (sizes && sizes.filter((x) => x.IsActive)[0]) ?? {}
  );
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();

  const handleChange = (event) => {
    setSelectedSize(event.target.value);
    window.location = event.target.value.Url;
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <div>
      <FormControl className={classes.root} fullWidth>
        <div className="product-detail__sizeselect-label">
          {translate('productdetails.select-size')}:
        </div>
        <Select
          id="product-detail__sizeselect"
          className="product-detail__sizeselect"
          value={selectedSize}
          label={translate('productdetails.select-size')}
          open={open}
          MenuProps={MenuProps}
          onClose={handleClose}
          onOpen={handleOpen}
          onChange={handleChange}
        >
          {sizes.map((size) => (
            <MenuItem
              className="product-detail__sizeselect-option"
              value={size}
              disabled={!size.Enabled}
            >
              <span>{size.Title}</span>{' '}
              <span className="sizeselect__inventory">
                {!size.Enabled
                  ? translate('out-of-stock')
                  : translate('in-stock')}
              </span>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default ProductSizeSelector;
